import $http from '../services/AxiosInstance';

export interface LogsMailFilters {
  from?: string | null;
  to?: string | null;
  subject?: string | null;
  /** YYYY-MM-DD */
  startDate?: string | null;
  /** YYYY-MM-DD */
  endDate?: string | null;
}

interface Params {
  page: number;
  filters?: LogsMailFilters;
}

// El backend rechaza parámetros vacíos, así que solo se envían los que tienen valor.
const withoutEmpty = (filters: LogsMailFilters = {}) => Object.fromEntries(
  Object.entries(filters)
    .map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value])
    .filter(([, value]) => value !== null && value !== undefined && value !== ''),
);

class LogsMailRepository {
  async getlogsMail({ page, filters }: Params) {
    try {
      const response = await $http.get('/logMail', {
        params: { page, ...withoutEmpty(filters) },
      });
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  async reSendEmail(id: number) {
    try {
      const response = await $http.post('/logMail', { id });
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
}

export default LogsMailRepository;
